import * as t from 'io-ts';
import { ApiContractCodec } from './types';

export const AdminContractCodec = ApiContractCodec;

export const AdminContractsResponseCodec = t.type({
    contracts: t.array(AdminContractCodec),
});
